type SqlClient = {
  query<T = any>(sql: string): Promise<{ rows: T[] }>;
  exec(sql: string): Promise<unknown>;
};

export async function ensureEventsSchemaCompatibility(client: SqlClient): Promise<void> {
  const eventsTableExists = await client.query<{ exists: boolean }>(`
    SELECT EXISTS (
      SELECT 1
      FROM information_schema.tables
      WHERE table_schema = 'public'
        AND table_name = 'events'
    ) AS "exists";
  `);

  if (!eventsTableExists.rows[0]?.exists) {
    return;
  }

  const hasKeyColumn = await client.query<{ exists: boolean }>(`
    SELECT EXISTS (
      SELECT 1
      FROM information_schema.columns
      WHERE table_schema = 'public'
        AND table_name = 'events'
        AND column_name = 'key'
    ) AS "exists";
  `);

  if (!hasKeyColumn.rows[0]?.exists) {
    await client.exec('ALTER TABLE "events" ADD COLUMN "key" uuid DEFAULT gen_random_uuid();');
    await client.exec('DROP INDEX IF EXISTS "slug_idx";');
    await client.exec('CREATE UNIQUE INDEX IF NOT EXISTS "slug_idx" ON "events" USING btree ("key");');
  }

  const hasSlugColumn = await client.query<{ exists: boolean }>(`
    SELECT EXISTS (
      SELECT 1
      FROM information_schema.columns
      WHERE table_schema = 'public'
        AND table_name = 'events'
        AND column_name = 'slug'
    ) AS "exists";
  `);

  if (hasSlugColumn.rows[0]?.exists) {
    await client.exec('ALTER TABLE "events" DROP COLUMN "slug";');
  }
}
